import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {RankingServiceProvider} from "../ranking-service/ranking-service";
import {PlayerServiceProvider} from "../../../core/services/player-service/player-service";
import { TaskDefinition } from "../../interfaces/task-definition";
import { RankingDefinition } from "../ranking-service/ranking-definition";

@Injectable()
export class CampaignServiceProvider {
  playerCampaigns = [];

  constructor(public http: HttpClient, private playerService:PlayerServiceProvider ,
              private rankingService:RankingServiceProvider) {}

  load(){
    return new Promise((resolve, reject) => {
      Promise.all([this.playerService.getPlayer(),this.rankingService.getRankingDefinitions()])
        .then((response:any)=>{
          let player = response[0];
          let rankingsDefinition = response[1];
          this.playerCampaigns = [];
          let allPlayerCampaigns = null;

          if (player && player.params && player.params.campaignMember) {
            allPlayerCampaigns = player.params.campaignMember;
          }

          if (allPlayerCampaigns && allPlayerCampaigns.length > 0) {
            for (let i = allPlayerCampaigns.length - 1; i >= 0; i--) {
              for (let j = 0; j < rankingsDefinition.length; j++) {
                if (rankingsDefinition[j].params.campaign && allPlayerCampaigns[i] === rankingsDefinition[j].params.campaign) {
                  this.playerCampaigns.push(allPlayerCampaigns[i]);
                  break;
                }
              }
            }

            if (this.playerCampaigns.length >= 1) {
              let currentCampaign = this.getCurrentCampaign();

              if (currentCampaign && currentCampaign === 'null' || currentCampaign === null) {
                currentCampaign = this.playerCampaigns[0];
                this.setCurrentCampaign(currentCampaign);
              }
            }
          }
          resolve();
        }).catch(err=>{
          console.error(err);
          reject(err);
      })
    })
  }

  filterRankingsDefinitionsByCampaignIfDefined(rankingDefinitions: RankingDefinition[]): RankingDefinition[] {
    let currentCampaign = this.getCurrentCampaign();
    if (this.playerCampaigns.length > 1 && (currentCampaign && currentCampaign !== 'null' || currentCampaign !== null)) {
      let response: RankingDefinition[] = [];


      for (let j = 0; j < rankingDefinitions.length; j++) {
        if (rankingDefinitions[j].params.campaign && rankingDefinitions[j].params.campaign === currentCampaign) {
          response.push(rankingDefinitions[j]);
        }
      }

      return response;
    }
    else {
      return rankingDefinitions;
    }
  }

  getTargetsDefinition(targetsDefinitions: Map<number, TaskDefinition>, tasksIds: number[]) {
    let filteredTargetDefinitions = {};
    tasksIds.forEach(taskId => {
      filteredTargetDefinitions[taskId] = targetsDefinitions[taskId];
    });

    //TODO prawdopodobnie do zaorania
    let currentCampaign = this.getCurrentCampaign();
    if (this.playerCampaigns.length > 1 && (currentCampaign && currentCampaign !== 'null' || currentCampaign !== null)) {

      for (let task in targetsDefinitions) {
        const campaign = filteredTargetDefinitions[task].params.campaign;
        if (!campaign || campaign !== currentCampaign) {
          delete filteredTargetDefinitions[task];
        }
      }
    }
    return filteredTargetDefinitions;
  }

  getUserCampaigns() {
    return this.playerCampaigns;
  }
  resetPlayerCampaigns() {
    this.playerCampaigns = [];
    this.setCurrentCampaign(null);
  }
  setCurrentCampaign(campaign): Promise<void> {
    return new Promise<void>((resolve) => {
      this.rankingService.setFilters(null);
      this.rankingService.setGroupFilters(null);
      window.localStorage.setItem('currentCampaign', campaign);
      resolve();
    });
  }
  getCurrentCampaign() {
    return window.localStorage.getItem('currentCampaign') || null;
  }
}



// WEBPACK FOOTER //
// ./src/modules/ranking/services/campaign-service/campaign-service.ts